module.exports = __webpack_public_path__ + "img/gogol-park.956fec1e.png";